import React from 'react'
import { CircularProgress } from '@mui/material';

export default function Spinner(props) {

    const { width, height, color, ...other } = props

    return (
        <CircularProgress
            sx={{
                width: {width},
                height: {height},
                color: {color}
            }}
            {...other}/>
    )
}
